import { RefObject } from 'react'
import classNames from 'classnames'
import { Button, Modal } from '@collegebacker/backer-ui/ui'

import { CopyLinkButton } from 'components'
import config from 'config'

import styles from './SetupModal.module.scss'

const SetupModal = ({
  modalRef,
  handle,
  isNC529
}: {
  modalRef: RefObject<any>
  handle: string
  isNC529: boolean
}) => {
  return (
    <Modal ref={modalRef} contentClassName="typo-app-body-large-paragraph">
      <div>
        <h3 className="typo-app-title-medium">Your gifting page is ready</h3>
      </div>
      <div className={styles.copyLinkContainer}>
        <div className={styles.copyLinkLeft}>
          <p className={styles.linkEmoji}>&#128279;</p>
          <span className={styles.handle}>
            <span>{config.BACKEND_ROOT_URL.split('://')[1]}/</span>
            <span>{handle}</span>
          </span>
        </div>
        <CopyLinkButton
          label="Copy"
          link={`${config.BACKEND_ROOT_URL}/${handle}`}
          modifier="setup-modal"
        />
      </div>
      {isNC529 && (
        <ul className={styles.list}>
          <li
            className={classNames('typo-app-body-paragraph', styles.listItem)}
          >
            Share this link with family and friends, so they can contribute
            gifts directly into your 529 account. Click Settings in the top
            right to view your gifts.
          </li>

          <li
            className={classNames('typo-app-body-paragraph', styles.listItem)}
          >
            You can return to this page from your NC 529 Plan dashboard and do
            not need to create a Backer account.
          </li>
        </ul>
      )}
      <Button
        label="See your gifting page"
        onClick={() => modalRef?.current?.close()}
        minWidth={335}
      />
    </Modal>
  )
}

export default SetupModal
